module.exports = __webpack_public_path__ + "img/minus-circle.484b1d07.svg";